import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { X, Tag, StickyNote } from 'lucide-react';

const FavoriteQualificationModal = ({ isOpen, onClose, onSave, resourceName }) => {
  const [tags, setTags] = useState('');
  const [notes, setNotes] = useState('');
  const [currentTag, setCurrentTag] = useState('');

  if (!isOpen) return null;

  const handleAddTag = () => {
    if (currentTag.trim()) {
      const newTags = tags ? `${tags},${currentTag.trim()}` : currentTag.trim();
      setTags(newTags);
      setCurrentTag('');
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    const tagArray = tags.split(',').filter(t => t.trim() !== tagToRemove);
    setTags(tagArray.join(','));
  };

  const handleSave = () => {
    onSave({
      tags: tags.split(',').map(t => t.trim()).filter(t => t),
      notes: notes.trim()
    });
    setTags('');
    setNotes('');
    setCurrentTag('');
  };

  const handleSkip = () => {
    onClose();
    setTags('');
    setNotes('');
    setCurrentTag('');
  };

  const tagArray = tags.split(',').map(t => t.trim()).filter(t => t);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-semibold" style={{ color: '#1B3240' }}>
            Qualify Favorite
          </h3>
          <button onClick={handleSkip} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>

        <p className="text-sm text-gray-600 mb-4">
          Add tags and notes for <strong>{resourceName}</strong> (optional)
        </p>

        {/* Tags Section */}
        <div className="mb-4">
          <Label className="flex items-center mb-2">
            <Tag className="w-4 h-4 mr-1" />
            Tags
          </Label>
          <div className="flex gap-2 mb-2">
            <Input
              value={currentTag}
              onChange={(e) => setCurrentTag(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleAddTag()}
              placeholder="Type a tag and press Enter"
              className="flex-1"
            />
            <Button onClick={handleAddTag} size="sm" style={{ backgroundColor: '#62D84E' }}>
              Add
            </Button>
          </div>
          {tagArray.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {tagArray.map((tag, idx) => (
                <span
                  key={idx}
                  className="px-3 py-1 bg-purple-100 text-purple-700 text-sm rounded-full flex items-center gap-1"
                >
                  {tag}
                  <button
                    onClick={() => handleRemoveTag(tag)}
                    className="hover:text-purple-900"
                  >
                    <X className="w-3 h-3" />
                  </button>
                </span>
              ))}
            </div>
          )}
        </div>

        {/* Notes Section */}
        <div className="mb-6">
          <Label className="flex items-center mb-2">
            <StickyNote className="w-4 h-4 mr-1" />
            Private Notes
          </Label>
          <Textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Add any private notes about this resource..."
            rows={4}
            className="w-full"
          />
        </div>

        {/* Action Buttons */}
        <div className="flex gap-3">
          <Button
            onClick={handleSave}
            style={{ backgroundColor: '#62D84E' }}
            className="flex-1"
          >
            Save & Continue
          </Button>
          <Button
            onClick={handleSkip}
            variant="outline"
            className="flex-1"
          >
            Skip
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FavoriteQualificationModal;
